// extracted by mini-css-extract-plugin
export default {"titleCircle":"circleTitle_titleCircle__0MPaH","innerCircle":"circleTitle_innerCircle__OzhaB","text":"circleTitle_text__loMDD","ru":"circleTitle_ru__C4pGg"};